import React from 'react';
import PropTypes from 'prop-types';

function VisaCardIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="24"
      viewBox="0 0 34 24"
      className={className}
    >
      <g fill="none" fillRule="evenodd">
        <rect width="33" height="23" x=".5" y=".5" fill="#FFF" stroke="#E1E1E1" rx="3" />
        <path
          fill="#024C9D"
          fillRule="nonzero"
          d="M17 10.9c0 1.2 1 2 1.9 2.3.8.5 1.1.7 1.1 1.1 0 .6-.7.9-1.3.9-1.1 0-1.7-.3-2.2-.6l-.4 2c.5.2 1.4.4 2.4.4 2.3 0 3.8-1.2 3.8-3 0-2.3-3-2.4-3-3.4 0-.3.2-.7.9-.8a4 4 0 0 1 2.1.4l.4-1.8a5.7 5.7 0 0 0-2-.4C18.4 8 17 9.2 17 10.9m9.4-2.7a1 1 0 0 0-1 .6l-3.2 8h2.3l.4-1.2h2.8l.3 1.3h2l-1.8-8.7h-1.8m.3 2.3l.7 3.3h-1.9l1.2-3.3M14.2 8.2l-1.8 8.7h2.2l1.8-8.7h-2.2m-3.2 0L8.7 14l-1-5c0-.6-.5-1-1-1H3.2l-.1.3 2.2.8c.3.1.4.3.5.7l1.7 7h2.3l3.6-8.7H11"
        />
      </g>
    </svg>
  );
}

VisaCardIcon.propTypes = {
  className: PropTypes.string,
};

export default VisaCardIcon;
